<template>
  <ion-card class="task-card ml-0 mr-3 clickable-item-hov">
    <div class="h-100 w-100" @click="taskAction">
      <ion-badge class="completed" color="tertiary" v-if="task.user_submission_count" title="Done!"><i class="ti-check" /></ion-badge>
      <div class="one-event">
        <div class="d-flex justify-content-center">
          <img class="event-img" v-image :src="task.event_image_url" />
        </div>
        <div class="name d-flex justify-content-center mt-2 text-center px-2 py-1 title">
          {{ task.name }}
        </div>
      </div>
      <p class="px-2 py-0 my-0 text-center">
        <p v-if="!task.starts_at || !task.ends_at"></p>
        <p v-else-if="dateHasPassed(task.starts_at)"> <!-- Ongoing -->
          <vue-countdown :time="formatFromNowInMilliseconds(task.ends_at)" v-slot="{ days, hours, minutes, seconds }" @end="onEnd">
            <span :class="showRefreshTimer(task) ? 'text-tertiary' : 'text-primary'"><span v-if="showRefreshTimer(task)">Restarts in</span><span v-else>Ends in</span><br/><span v-if="days">{{ days }}d </span><span v-if="hours">{{ hours }}h </span><span v-if="!days">{{ minutes }}m </span><span v-if="!days && !hours">{{ seconds }}s</span></span>
          </vue-countdown>
        </p>
        <p v-else> <!-- Upcoming -->
          <vue-countdown :time="formatFromNowInMilliseconds(task.starts_at)" v-slot="{ days, hours, minutes, seconds }" @end="onEnd">
            <span class="upcoming">Starts in<br/><span v-if="days">{{ days }}d </span><span v-if="hours">{{ hours }}h </span><span v-if="!days">{{ minutes }}m </span><span v-if="!days && !hours">{{ seconds }}s</span></span>
          </vue-countdown>
        </p>
      </p>
      <router-link v-if="showEventBadge(task)" :to="toEvent(task.event_slug!)" target="_blank" @click.stop><ion-badge 
        class="event-badge clickable-item-hov" 
        color="secondary" 
        v-if="task.event_title" :title="task.event_title"
      >{{ truncate(task.event_title, 17) }}</ion-badge></router-link>
    </div>
  </ion-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { SiteEventTask } from '@/types/static-types';
import { dateHasPassed, formatFromNowInMilliseconds } from '@/utils/dateTime';
import { truncate } from '@/utils/string';

export default defineComponent({
  name: 'EventTaskCard',
  props: {
    task: { type: Object as PropType<SiteEventTask>, required: true },
    openCharacterRoulette: { type: Function, required: true },
    openArtRoulette: { type: Function, required: true }
  },
  computed: {
  },
  methods: {
    truncate,
    formatFromNowInMilliseconds,
    dateHasPassed,
    onEnd() {
      this.$emit('end', this.task);
    },
    taskAction() {
      const task = this.task!
      if (!this.task) return;
      if (task.response_type === 'A') {
        if ((task.action_url || '').includes('?quest=cr')) {
          return this.openCharacterRoulette();
        }
      }
      const router = useRouter()
      if (task.response_type === 'A') {
        if ((task.action_url || '').includes('?quest=ar')) {
          return this.openArtRoulette();
        }
      }
      if (task.task_type === 'poll') router.push(`/events/poll/${this.task.id}/`);
      else router.push(`/events/task/${task.id}/`);
    },
    toEvent(slug: string) {
      return `/events/event/${slug}/`;
    },
    showEventBadge(task: SiteEventTask) {
      if (task.event_slug === 'character-roulette') return false;
      return true;
    },
    showRefreshTimer(task: SiteEventTask) {
      return task.user_submission_count && task.will_refresh;
    }
  }
})
</script>

<style lang="sass">
ion-badge
  padding-left: 5px
  padding-right: 5px
p
  margin: 0rem 0 0.75rem 0
.task-card
  transition: 150ms ease all
  overflow: unset !important
  background-color: #fff
  border: 1px solid #CCC
  border-radius: 8px
  width: 160px
  min-width: 109px
  @media(min-width: 420px)
    min-width: 200px !important
    max-width: 200px !important
  @media(max-width: 419px)
    min-width: 170px !important
    max-width: 170px !important
.one-event
  img
    width: 100% !important
    height: 150px !important
    object-fit: cover
    border-radius: 5px 5px 0 0  
  .name
    font-size: 18px
    font-weight: bold
    color: #737373
    cursor: pointer
.upcoming
  color: gray
.dark .text-primary
  color: white
.dark .text-tertiary
  color: gray
.completed
  position: absolute
  top: 5px
  right: 5px
.event-badge
  position: absolute
  top: 5px
  left: 5px
  max-width: 75%
</style>